import React, { Component } from 'react';
import { API_URL } from '../../utils/config';

import './InputListImages.css';

interface Props {
    type: 'text' | 'select' | 'number'
    label: string | React.ReactNode
    values: Array<any>
    onChange: (values: Array<any>) => void
    placeholder?: string
}
interface State {
    value: string
}


export default class InputListImages extends Component<Props, State>{
    constructor(props: Props) {
        super(props);
        this.state = {
            value: ''
        }
    }

    render() {
        return (
            <>
                {
                    this.props.values.length > 0 &&
                    <div className="rt-input-list-uploaded-images">
                        {
                            this.props.values.map((_, index: number) => (
                                <div className="image-item">
                                    {this.get_image(index)}

                                    <div className="image-item-btn-wrapper">
                                        <button className="remove-image" onClick={() => this.remove_value(index)}>&times;</button>
                                    </div>

                                </div>
                            ))
                        }
                    </div>
                }
            </>
        );
    }
    remove_value = (index: number) => {
        let { values } = this.props;
        values.splice(index, 1);
        this.props.onChange(values);
        this.forceUpdate();
    }

    get_image = (index: number) => {
        return <img className="uploaded-image-img" src={`${API_URL}/data${this.props.values[index]}`} />;
    }

    get_input = (index?: number) => {
        switch (this.props.type) {
            case 'text':
            case 'number':
                return (<input
                    placeholder={this.props.placeholder}
                    type={this.props.type} value={index !== undefined ? this.props.values[index] : this.state.value}
                    onChange={(e) => {
                        if (index !== undefined) {
                            this.props.values[index] = e.target.value;
                            this.forceUpdate();
                        }
                        else {
                            this.setState({ value: e.target.value })
                        }
                    }}
                // onKeyDown={index !== undefined ? undefined : this.keypress_handler}
                />)
            default: return null
        }
    }

};